import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import moment from 'moment';
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import backIcons from '../../../assets/images/back-icon.png';
import searchIcons from '../../../assets/images/search-icon.png';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import BuyerOrgHeader from '../../BuyerOrgHeader';
import { getShowingsList } from '../../../actions/organisation';
import { openSnackBar } from '../../../actions/snack-bar'
import Typography from '@material-ui/core/Typography';
import ViewBuyerDetailsModal from './ViewBuyerDetailsModal';
import { CircularProgress } from '@material-ui/core';
import constants from '../../../config/constant';

const { ROLE } = constants;
class ShowingsList extends React.Component {
  state = {
    showingsList: [],
    loading: false,
    keyword: '',
    isAdmin: false
  }
  componentDidMount() {
    const { location: { state }, history, authentication: { authenticatedUser: { role } } } = this.props;
    if (!state || !state.realtorName) history.push('/organization/dashboard');
    else this.getShowingsList();
    if (role === ROLE.ADMIN) this.setState({ isAdmin: true });
  }

  getShowingsList = () => {
    const { keyword } = this.state;
    const realtorId = this.props.match.params.id;
    this.setState({ loading: true });
    this.props
      .dispatch(getShowingsList(realtorId, keyword))
      .then(response => {
        this.setState({ showingsList: response.data, loading: false });
      })
      .catch(err => {
        this.setState({ loading: false });
        const message = err && err.message;
        this.props.dispatch(
          openSnackBar({
            message
          })
        )
      })
  }

  viewBuyerDetails = (userId, address) => {
    this.props.dispatch({
      type: 'VIEW_BUYER_DETAILS', payload: true, buyerId: userId, address, showReview: this.state.isAdmin
    });
  }

  setKeyword = (event) => {
    this.setState({ keyword: event.target.value });
  };

  searchKeyword = (event, getList = false) => {
    if (event.key === 'Enter' || getList) {
      this.getShowingsList();
    }
  }

  render() {
    const { showingsList } = this.state;
    const { classes, location: { state }, showBuyerDetailsModal } = this.props
    const realtorName = (state && state.realtorName) || '';
    return (
      <div>
        <BuyerOrgHeader authentication={this.props.authentication} />
        <div className={classes.pageLoader}>
          {this.state.loading && <CircularProgress size={60} />}
        </div>
        <div className={classes.container}>
          <div className={classes.innerWrap}>
            <div className={classes.headingWrap}>

              <Typography
                variant="h2"
                className={classes.headingWrapheading}>
                <a href="#">
                  <img
                    src={backIcons}
                    alt="back Icon"
                    onClick={() => this.props.history.goBack()}
                  />
                </a> {`${realtorName}`}’s all showings
            </Typography>

              <div className={classes.headingButtonWrap}>

                <Paper className={classes.searchInput}>

                  <InputBase
                    className={classes.input}
                    placeholder="Search Showing"
                    inputProps={{ 'aria-label': 'Search Showing' }}
                    onChange={this.setKeyword}
                    onKeyPress={this.searchKeyword}
                  />
                  <IconButton onClick={(e) => this.searchKeyword(e, true)} className={classes.iconButton} aria-label="search">
                    <img
                      src={searchIcons}
                      alt="Search Icon"

                    />
                  </IconButton>

                </Paper>
              </div>
            </div>
            <div className={classes.dashboardTable}>

              <Table >
                <TableHead>
                  <TableRow>
                    <TableCell>Showing Date & Time</TableCell>
                    <TableCell>Buyer Name</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {showingsList.map(realtor => {
                    const { id, buyer_fname, buyer_lname, buyer_id, created, city, country, state, street_number } = realtor;
                    const addresss = `${street_number}, ${city}, ${state}, ${country}`
                    const formattedDateTime = moment(created).format('MMMM, Do YYYY, hh:mm:ss A')
                    return (
                      <TableRow key={id}>
                        <TableCell component="th">{formattedDateTime}</TableCell>
                        <TableCell>{`${buyer_fname} ${buyer_lname}`}</TableCell>
                        <TableCell>{addresss}</TableCell>
                        <TableCell> <button onClick={() => this.viewBuyerDetails(buyer_id, addresss)} className={classes.buyerDetailBtn}>View Buyer Details</button>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
              {!this.state.loading && !this.state.showingsList.length &&
                <Typography variant="h2" className={classes.noResultFound}>
                  No Result Found
              </Typography>}
            </div>
          </div>
          <div className={classes.copyright}>
            @2019 SafeShowings. All Right <span>Reserved</span>
          </div>
        </div>
        {showBuyerDetailsModal && <ViewBuyerDetailsModal open={showBuyerDetailsModal} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    updatingUser: state.users.updatingUser,
    showBuyerDetailsModal: state.modalHandler.viewBuyerDetails
  }
}
const mapActionsToProps = dispatch => {
  return {
    dispatch
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withStyles(styles)
)(ShowingsList)


